import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseURL, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const axiosInstance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);
  return {
    cjTracking
  };

  function cjTracking(params) {
    return axiosInstance.post('/tracking', params).then(r => {
      return r.data;
    });
  }
}